import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Button } from 'advenio-components'
import AvgDailyRatings from './AvgDailyRatings'
import AvgMonthlyRatings from './AvgMonthlyRatings'
import DailyRatings from './DailyRatings'
import MonthlyRatings from './MonthlyRatings'
import PoorRatings from './PoorRatings'
import RecentRatings from './RecentRatings'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`
const ReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`
const TitleContainer = styled.div`
  width: 100%;
  padding: 30px 30px 30px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

class RatingsReports extends Component {
  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('ratings', this.props.activeCenter)
    } else {
      this.props.getRatingsExcel()
    }
  }

  render() {
    const { fromCenter, match } = this.props

    return (
      <Container>
        <TitleContainer>
          {!fromCenter && <h1>Ratings</h1>}
          <Button primary onClick={this.download}>Descargar Excel</Button>
        </TitleContainer>
        <ReportContainer>
          <PoorRatings match={match} fromCenter={fromCenter} />
          <RecentRatings match={match} fromCenter={fromCenter} />
          <AvgDailyRatings match={match} fromCenter={fromCenter} />
          <AvgMonthlyRatings match={match} fromCenter={fromCenter} />
          <DailyRatings match={match} fromCenter={fromCenter} />
          <MonthlyRatings match={match} fromCenter={fromCenter} />
        </ReportContainer>
      </Container>
    )
  }
}

const mapStateToProps = ({ centersInfo }) => ({
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getRatingsExcel: () => dispatch(RatingsActions.RatingsExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RatingsReports)



// WEBPACK FOOTER //
// ./src/Containers/Reports/RatingsReports.jsx